import { useContext, useEffect, useState } from 'react';

import { CssVarsType, useThemeType, IThemeContext, ModulesThemesType } from '@themes/themeTypes';
import { ThemeContext, THEME_MODULE, THEME_TYPE } from '@themes/themeContext';

import { themeConfig } from '@themes/themesConfig';
import { authThemeCfg } from '@auth_module/theme/config';
import { accountThemeCfg } from '@account_module/theme/config';
import { insightsThemeCfg } from '@insights_module/theme/config';

const initialThemeCfg = authThemeCfg[THEME_TYPE.DARK];

export const useTheme = (): useThemeType => {
  const { theme, saveUserPrefs, moduleTheme } = useContext(ThemeContext) as IThemeContext;
  const [cssVars, setCssVars] = useState<CssVarsType>(initialThemeCfg);
  const isDark = theme === THEME_TYPE.DARK;
  const toggleTheme = () => saveUserPrefs(isDark ? THEME_TYPE.LIGHT : THEME_TYPE.DARK);

  // This object specifies which modules are supported for theme configuration.
  // Each solution module should have a corresponding /theme/config file (eg. auth/theme/authThemeCfg.ts)
  // from which we will pull data and overwrite default theme settings.
  const moduleThemes: ModulesThemesType = {
    auth: {
      id: 0,
      name: THEME_MODULE.AUTH,
      cfg: authThemeCfg[theme as keyof typeof authThemeCfg],
    },
    insights: {
      id: 1,
      name: THEME_MODULE.INSIGHTS,
      cfg: insightsThemeCfg[theme as keyof typeof insightsThemeCfg],
    },
    account: {
      id: 3,
      name: THEME_MODULE.ACCOUNT,
      cfg: accountThemeCfg[theme as keyof typeof accountThemeCfg],
    },
  };

  useEffect(() => {
    setCssVars({
      ...themeConfig[theme as keyof typeof themeConfig],
      ...moduleThemes[moduleTheme as keyof typeof moduleThemes]?.cfg,
    });
  }, [theme, moduleTheme]);

  return { cssVars, theme, isDark, toggleTheme, moduleTheme };
};
